import React, { useState, useEffect } from 'react'
import { Navigation } from '@cwp/amp-microsites/build/components.es.js'
import { APIENDPOINT, getCWPEnvironmentForURL } from '../../shared/utils/common-utils'
import { useFetch } from '../../shared/utils/hooks'
import { reactToCwp } from '../../../common/react-utils'

const NavigationMicrosite = props => {
  const { menuName, layout, textClass } = props.content
  const [windowWidth, setWindowWidth] = useState(0)

  useEffect(() => {
    const handleWindowSizeChange = () => {
      setWindowWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleWindowSizeChange)
    setWindowWidth(window.innerWidth)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])
  const env = getCWPEnvironmentForURL(window.location.href)
  const micrositeMenuUrl = `${APIENDPOINT(env).menuBaseWithParams}${menuName}`
  const micrositeMainMenu = useFetch(windowWidth >= 1025 ? micrositeMenuUrl : '')
  const { status: menuStatus, error: menuError } = micrositeMainMenu

  switch (menuStatus) {
    case 'idle': {
      return <div />
    }
    case 'error': {
      return <div>{menuError}</div>
    }
    case 'fetching': {
      return <div className='loading' />
    }
    default: {
      return (
        <Navigation
          mainMenu={micrositeMainMenu}
          layoutClass={layout}
          textSizeClass={textClass}
          styles={{
            navBackgroundColor: '#F5F5F5',
            linkTextColor: '#046cb8',
            linkTextColorHover: '#00284a',
            navTabHoverBorderBottom: 'rgba(0, 40, 75, 0.5)',
            navTabHoverBackgroundColor: '#F5F5F5',
            navTabSelectedBorderBottom: '#00284a',
          }}
        />
      )
    }
  }
}

export default reactToCwp(NavigationMicrosite)
